<template>
  <div class="payTypeSubscriptSmall">
    <img class="commonVip" v-if="showWho == 'commonVip'" />
    <img class="companyVip" v-if="showWho == 'companyVip'" />
    <span class="price" v-if="showWho == 'price'">￥{{ item.price }}</span>
    <span class="discount" v-if="showWho == 'discount'"
      >￥{{ item.price }}</span
    >
    <img class="bought" v-if="showWho == 'bought'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "payTypeSubscriptSmall",
  components: {},
  props: {
    item: {
      payType: 0,
      price: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["UserLevelType"]),

    showWho: function () {
      if (this.item.payType == 0) {
        return "free";
      } else if (this.item.payType == 1 && this.UserLevelType < 3) {
        if (this.item.tt) {
          return "bought";
        } else {
          return "price";
        }
      } else if (this.item.payType == 4) {
        return "commonVip";
      } else if (this.item.payType == 6) {
        return "companyVip";
      } else {
        return "free";
      }
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.payTypeSubscriptSmall {
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.free {
  display: none;
}
.price,
.discount {
  background: linear-gradient(108deg, #fa2efc 0%, #325eff 99%);
  border-radius: 4px;
  font-size: 10px;
  color: #fff;
  padding: 0 6px;
}
.bought {
  width: 50px;
  height: 16px;
  content: url("../../../static/svg/payTypeSubscript/bought50x14.svg");
}
.commonVip {
  width: 36px;
  height: 16px;
  content: url("../../../static/svg/payTypeSubscript/vip36x14.svg");
}
.companyVip {
  width: 50px;
  height: 16px;
  content: url("../../../static/svg/payTypeSubscript/companyVip50x14.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/common/payTypeSubscriptSmall.vue